import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IBlog } from "../blogModel";
import moment from "moment";

export const getAllBlog = createAsyncThunk("Blog/FindAllBlog", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Blog/FindAllBlog`,
      {
        Title: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Blog:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createBlog = createAsyncThunk(
  "Blog/InsertBlog",
  async (BlogData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Blog/InsertBlog`,
        BlogData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateBlog = createAsyncThunk(
  "Blog/UpdateBlog",
  async (BlogData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Blog/UpdateBlog`,
        BlogData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Blog :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteBlog = createAsyncThunk(
  "Blog/DeleteBlog",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Blog/DeleteBlog`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Blog :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getBlogByID = createAsyncThunk(
  "Blog/FindByIDBlog",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Blog/FindByIDBlog`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        ShortDescription: result.ShortDescription,
        Keyword: result.Keyword,
        Description: result.Description,
        BlogURL: result.BlogURL,
        MetaTitle: result.MetaTitle,
        MetaDescription: result.MetaDescription,
        BlogDate: result.BlogDate
          ? moment(result.BlogDate, "MM/DD/YYYY").toDate()
          : "",
        Image: result.Image,
        BlogBannerImage: result.BlogBannerImage,
        IsActive: result.IsActive ? 1 : 2,
      } as IBlog;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Blog :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveBlog = createAsyncThunk(
  "Blog/FindAllActiveBlog",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Blog/FindAllActiveBlog`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveBlog = createAsyncThunk(
  "Blog/ActiveInActiveBlog",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Blog/ActiveInActiveBlog`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Blog :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const BlogImageUpload = createAsyncThunk(
  "Blog/BlogImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Blog/BlogImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Blog Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
